var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateEventbackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 400,
    viewBox: "0 0 435 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_547_6550)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 435,
    height: 400,
    rx: 8,
    fill: "#A2C166"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_547_6550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.5 215.5C285.893 410.159 -183.382 347.203 -8.86998 164L-115.5 223.801V478L519 491.5V275.5L441.5 215.5Z",
    fill: "#8DB247"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_547_6550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 435,
    height: 400,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_547_6550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436,
    height: 194,
    fill: "white",
    transform: "translate(0 206)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateEventbackground);
export default __webpack_public_path__ + "static/media/createEventbackground.2cc1a3813c6aafaac0215c85afe5bc92.svg";
export { ForwardRef as ReactComponent };